/* Import External Modules */
import React from 'react'

/* Import Leverege Modules */
import { List } from '@leverege/ui-elements'

/* Import Local Modules */
import style from './style.css'
import ListModal from '../../views/ListModal';

/**
 * Selector for template boilerplates.
 */
export default class TemplateSelector extends React.Component {

  /**
   * Renders template dialog selector
   */
  render() {

    // Get parameters
    const { templates, userTemplates, show, onClick, onClose } = this.props
    const userTemplateAliases = userTemplates.items.map( t => t.alias ).filter( t => t != null )

    // Initialize list items
    const templateListItems = templates.map( ( template ) => {
      const templateInUse = userTemplateAliases.includes( template.alias )
      return (
        <List.Item
          disabled={templateInUse}
          className={style.listItem}
          key={`${template.alias}-${template.name}`}
          item={template}>
          {template.name}
        </List.Item> 
      )
    } )
    
    // Return list modal
    return (
      <ListModal
        title="Templates"
        message="Select the type of template to add"
        mtypes={templateListItems}
        show={show}
        onClick={onClick}
        onClose={onClose} />
    )
  }
}
